import React, { useEffect, useState } from 'react';
import { Formik, Field, FieldArray, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import {
  Card,
  Table,
  Row,
  Col,
  Button,
  ListGroup,
  Alert,
  Form as BootstrapForm,
} from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AsyncSelect from 'react-select/async';
import { getSkills } from '../../../../services/SkillService';
import { getExpertise } from '../../../../services/ExpertiseService';
import { useAuth } from '../../../../context/authContext';
import { getProfile } from '../../../../store/selectors/AuthSelectors';
import { employeeSearchList } from '../../../../store/selectors/BoxSelectors';
import { useDispatch } from 'react-redux';
import { employeeSearchAction } from '../../../../store/actions/BoxActions';
import { getUsersSearch } from '../../../../services/BoxService';
import {
  createEmployeeSkill,
  getEmployeeSkillByEmail,
} from '../../../../services/EmployeeSkillsService';
import { useNavigate } from 'react-router-dom';

const EmployeeSkillForm = ({ profile, employeeList }) => {
  const [skills, setSkills] = useState([]);

  const [employee, setEmployee] = useState({});
  const [employeeName, setEmployeeName] = useState('');
  const [employeeId, setEmployeeId] = useState('');
  const [employeeEmail, setEmployeeEmail] = useState('');
  const [expertise, setExpertise] = useState([]);
  const dispatch = useDispatch();
  const categorizeData = (items) => {
    return items.reduce((acc, item) => {
      acc[item.category] = acc[item.category] || [];
      acc[item.category].push({ ...item, level: '' });
      return acc;
    }, {});
  };
  const navigate = useNavigate();
  const [showEmployeeList, setShowEmployeeList] = useState(false);
  const [singleEmployee, setSingleEmployee] = useState([]);
  useEffect(() => {
    const skillsModule = profile?.allowedModules?.find((module) => module.value === 'skills-form');
    if (skillsModule && skillsModule.operations.includes('employeelist')) {
      setShowEmployeeList(true);
    } else {
      setShowEmployeeList(false);
    }
  }, []);

  useEffect(() => {
    dispatch(employeeSearchAction(''));
  }, [dispatch]);

  const fetchEmployeeList = async (key = '') => {
    const response = await getUsersSearch(key);
    if (response?.data) {
      const formattedList = response.data.map((employee) => ({
        value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
        label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
        email: employee.email,
        employeeNumber: employee.employeeNumber,
      }));
      setSingleEmployee(formattedList);
    } else {
      setSingleEmployee([]);
    }
  };

  useEffect(() => {
    if (showEmployeeList) {
      fetchEmployeeList();
    } else {
      fetchEmployeeList(profile?.email);
    }
  }, [showEmployeeList, profile]);

  const loadOptions = (inputValue, callback) => {
    if (!inputValue) {
      callback([]);
      return;
    }
    getUsersSearch(inputValue)
      .then((response) => {
        const options = response.data.map((employee) => ({
          value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          email: employee.email,
          employeeNumber: employee.employeeNumber,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error('Error fetching employee data', error);
        callback([]);
      });
  };

  const [hierarchy, setHierarchy] = useState({});
  const [initialValues, setInitialValues] = useState({
    skills: skills.map((item) => ({
      _id: item._id,
      name: item.name.replace(/\s+/g, ' '),
      category: item.category.replace(/\s+/g, ' '),
      [`level-${item._id}`]: item.name.toLowerCase() == 'otherskills' ? 'No other skills' : 'none',
    })),
  });

  const handleChange = (id, target, setFieldValue) => {
    setFieldValue(target.name, target.value);
    let cat = initialValues.skills.map((item) => {
      if (id == item._id) {
        item[`level-${item._id}`] = target.value;
      } else {
        if (item.name.toLowerCase() == 'otherskills') {
          if (
            item[`level-${item._id}`].toLowerCase() == 'none' ||
            item[`level-${item._id}`] == ''
          ) {
            item[`level-${item._id}`] = item[`level-${item._id}`] || 'No other skills';
          } else {
            item[`level-${item._id}`] = item[`level-${item._id}`];
          }
        }
        if (item.name.toLowerCase() != 'otherskills') {
          item[`level-${item._id}`] = item[`level-${item._id}`] || 'none';
        }
      }
      return item;
    });
    setInitialValues((prev) => ({
      ...prev,
      skills: cat,
    }));
  };

  useEffect(() => {
    const fetchSkills = async () => {
      const response = await getSkills();
      setSkills(response);
    };
    fetchSkills();
    const fetchExpertise = async () => {
      const response = await getExpertise();
      const sortedExpertise = response.sort((a, b) => Number(a.sequence) - Number(b.sequence));
      setExpertise(sortedExpertise);
    };
    fetchExpertise();
  }, []);

  useEffect(() => {
    if (skills.length > 0) {
      setHierarchy(categorizeData(skills));
      setInitialValues({
        skills: skills.map((item) => ({
          _id: item._id,
          name: item.name.replace(/\s+/g, ' '),
          category: item.category.replace(/\s+/g, ' '),
          [`level-${item._id}`]:
            item.name.toLowerCase() == 'otherskills' ? 'No other skills' : 'none',
        })),
      });
    }
  }, [skills]);

  useEffect(() => {
    const setData = async () => {
      if (singleEmployee.length === 1) {
        const tempEmployee = singleEmployee[0];
        setEmployee(tempEmployee);
        setEmployeeEmail(tempEmployee.email);
        setEmployeeName(tempEmployee.value);
        setEmployeeId(tempEmployee.employeeNumber);
        const response = await getEmployeeSkillByEmail(tempEmployee.email);
        if (
          response &&
          response.length > 0 &&
          response[0].skills &&
          response[0].skills.length > 0
        ) {
          const tempSkills = skills.map((item) => {
            const matchedSkill = response[0].skills.find(
              (resSkill) =>
                resSkill.name.trim().toLowerCase() === item.name.trim().toLowerCase() &&
                resSkill.category.trim().toLowerCase() === item.category.trim().toLowerCase()
            );
            return {
              _id: item._id,
              name: item.name.replace(/\s+/g, ' '),
              category: item.category.replace(/\s+/g, ' '),
              [`level-${item._id}`]: matchedSkill ? matchedSkill.expertise : item.expertise,
            };
          });
          setInitialValues((prev) => ({
            ...prev,
            skills: tempSkills,
          }));
        } else {
          setInitialValues({
            skills: skills.map((item) => ({
              _id: item._id,
              name: item.name.replace(/\s+/g, ' '),
              category: item.category.replace(/\s+/g, ' '),
              [`level-${item._id}`]:
                item.name.toLowerCase() == 'otherskills' ? 'No other skills' : 'none',
            })),
          });
        }
      }
    };
    setData();
  }, [singleEmployee]); // Runs when employeeList changes

  const handleEmployeeChange = async (option) => {
    setEmployee(option);
    setEmployeeEmail(option.email);
    setEmployeeName(option.value);
    setEmployeeId(option.employeeNumber);
    const response = await getEmployeeSkillByEmail(option.email);
    if (response && response.length > 0 && response[0].skills && response[0].skills.length > 0) {
      const tempSkills = skills.map((item) => {
        const matchedSkill = response[0].skills.find(
          (resSkill) =>
            resSkill.name.trim().toLowerCase() === item.name.trim().toLowerCase() &&
            resSkill.category.trim().toLowerCase() === item.category.trim().toLowerCase()
        );
        return {
          _id: item._id,
          name: item.name.replace(/\s+/g, ' '),
          category: item.category.replace(/\s+/g, ' '),
          [`level-${item._id}`]: matchedSkill ? matchedSkill.expertise : item.expertise,
        };
      });
      setInitialValues((prev) => ({
        ...prev,
        skills: tempSkills,
      }));
    } else {
      setInitialValues({
        skills: skills.map((item) => ({
          _id: item._id,
          name: item.name.replace(/\s+/g, ' '),
          category: item.category.replace(/\s+/g, ' '),
          [`level-${item._id}`]:
            item.name.toLowerCase() == 'otherskills' ? 'No other skills' : 'none',
        })),
      });
    }
  };

  return skills.length > 0 ? (
    <>
      <ToastContainer />
      <Formik
        initialValues={initialValues}
        enableReinitialize={true}
        onSubmit={(values, { setSubmitting, setFieldError }) => {
          const formSkills = values.skills.map((item) => {
            let eValue = item[`level-${item._id}`];
            if (eValue == '' && item.name.toLowerCase() == 'otherskills') {
              eValue = 'No other skills';
            }
            return {
              category: item.category,
              name: item.name,
              expertise: eValue,
            };
          });

          if (employeeName == '' || typeof employeeName == 'undefined') {
            setFieldError('employee', 'Employee is required');
            return;
          }
          if (employeeId == '' || typeof employeeId == 'undefined') {
            setFieldError('employeeId', 'Employee Number is required');
            return;
          }
          if (employeeEmail == '' || typeof employeeEmail == 'undefined') {
            setFieldError('employeeEmail', 'Employee Email is required');
            return;
          }

          if (
            employeeName != '' &&
            typeof employeeName != 'undefined' &&
            employeeId != '' &&
            typeof employeeId != 'undefined' &&
            employeeEmail != '' &&
            typeof employeeEmail != 'undefined'
          ) {
            createEmployeeSkill({
              name: employeeName,
              email: employeeEmail,
              employeeNumber: employeeId,
              skills: formSkills,
            });
            toast.success('Form submitted successfully!');
            setSubmitting(false);
            // navigate("/skills-dashboard");
          } else {
            toast.error('Please fill Employee Info');
          }
        }}
      >
        {({ values, setFieldValue, handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            {/* Header Card */}
            <Card className="mb-4 text-white" style={{ backgroundColor: '#0131B9' }}>
              <Card.Body>
                <Row>
                  <Col xs={3} className="text-center">
                    <img
                      src="https://lists.office.com/Images/2b5a921a-a0e4-4eeb-919e-1e1cabeb9765/e6dac713-d737-4052-bd5d-47075d0eae85/T4MCOLI5RC2QYTNXYJ7OH089E0/ad461d91-d5d4-4f0b-906e-432ceef93632"
                      alt="SSAI Survey"
                      height={140}
                      width={140}
                    />
                  </Col>
                  <Col>
                    <Card.Title
                      className="mt-4"
                      as="h1"
                      style={{
                        marginLeft: '60px',
                        fontSize: '2.25rem',
                        color: '#fff',
                      }}
                    >
                      SSAI Scientific Skills Survey
                    </Card.Title>
                    <Card.Text
                      style={{
                        marginLeft: '60px',
                        fontSize: '1.25rem',
                        color: '#fff',
                      }}
                    >
                      This skills survey is designed to collect information about the scientific and
                      technical expertise of our employees. Please read the important instructions
                      below before attempting to complete the survey.
                    </Card.Text>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            {/* Instructions */}
            <Alert variant="warning">
              <strong>Reading these instructions could save you time!</strong>
            </Alert>

            <Card className="mb-4">
              <Card.Body>
                <Card.Title style={{ fontSize: '1.5rem' }}>Instructions:</Card.Title>
                <ListGroup variant="flush">
                  <ListGroup.Item>
                    <strong style={{ fontSize: '1rem' }}>
                      You do not need to respond to every question.
                    </strong>
                    If you do not have a particular skill, do not click on any of the radio buttons
                    for that item. Each skill automatically defaults to “None”. (Note: if you do
                    click on a skill but later want to unselect it, use the 'None' option.)
                  </ListGroup.Item>
                  <ListGroup.Item style={{ fontSize: '1rem' }}>
                    <strong>The purpose of this survey</strong> is to produce a skills database that
                    can be used to enhance employee collaboration and increase the effectiveness of
                    funding proposal efforts (from large company-wide proposal efforts down to
                    individual ROSES proposals).
                  </ListGroup.Item>
                  <ListGroup.Item style={{ fontSize: '1rem' }}>
                    <strong>This is not an anonymous survey.</strong> Your name and email address
                    will be included along with your responses since the purpose is to learn about
                    your skills.
                  </ListGroup.Item>
                  <ListGroup.Item style={{ fontSize: '1rem' }}>
                    <strong>Skill Level Definitions:</strong>
                    <ul>
                      <li>
                        <strong>Beginner (0 - 3 years):</strong> Requires guidance.
                      </li>
                      <li>
                        <strong>Intermediate (3 - 5 years):</strong> Can work independently.
                      </li>
                      <li>
                        <strong>Advanced (5+ years):</strong> Can mentor others.
                      </li>
                    </ul>
                  </ListGroup.Item>
                  <ListGroup.Item style={{ fontSize: '1rem' }}>
                    <strong>
                      You may revisit this survey at any future date to complete or update it.
                    </strong>{' '}
                    It doesn't have to be completed in a single pass
                  </ListGroup.Item>
                </ListGroup>
              </Card.Body>
            </Card>

            {/* Skill Selection Table */}
            {employeeList.length > 0 && (
              <Card className="mb-4">
                <Card.Body>
                  <Card.Title>Employee Info:</Card.Title>
                  <Row>
                    <Col className="">
                      <BootstrapForm.Group>
                        <BootstrapForm.Label>Employee Name</BootstrapForm.Label>
                        <AsyncSelect
                          cacheOptions
                          placeholder="Select employee..."
                          loadOptions={loadOptions}
                          defaultOptions={employeeList}
                          name="employee"
                          onChange={(option) => {
                            handleEmployeeChange(option);
                          }}
                          value={employee}
                          isDisabled={!showEmployeeList}
                        />
                        <ErrorMessage name="employee" component="div" className="text-danger" />
                      </BootstrapForm.Group>
                    </Col>

                    <Col>
                      <div className="form-group">
                        <label htmlFor="employeeEmail">Employee Email</label>
                        <Field
                          type="email"
                          name="employeeEmail"
                          className="form-control"
                          placeholder="Employee Email"
                          readOnly
                          value={employeeEmail}
                        />
                        <ErrorMessage
                          name="employeeEmail"
                          component="div"
                          className="text-danger"
                        />
                      </div>
                    </Col>

                    <Col>
                      <div className="form-group">
                        <label htmlFor="employeeEmail">Employee Number</label>
                        <Field
                          type="text"
                          name="employeeId"
                          className="form-control"
                          placeholder="Employee Number"
                          readOnly
                          value={employeeId}
                        />
                        <ErrorMessage name="employeeId" component="div" className="text-danger" />
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            )}
            <Card className="mb-4">
              <Card.Body>
                <Card.Title>Skill Selection</Card.Title>

                <FieldArray name="skills">
                  {() => {
                    // Step 1: Group skills by category with their real index
                    const groupedSkills = {};
                    values.skills.forEach((skill, realIndex) => {
                      if (!groupedSkills[skill.category]) {
                        groupedSkills[skill.category] = [];
                      }
                      groupedSkills[skill.category].push({
                        ...skill,
                        realIndex,
                      });
                    });

                    return Object.keys(hierarchy).map((category) => (
                      <div key={category} className="mb-4">
                        <h4
                          className="p-2 border rounded"
                          style={{
                            color: 'white',
                            fontSize: '1.3rem',
                            marginBottom: '-8px',
                            backgroundColor: '#0131B9',
                          }}
                        >
                          {category.toUpperCase()}
                        </h4>

                        <div className="table-responsive">
                          <Table striped bordered hover className="mt-2">
                            {category.toLowerCase() != 'other skills' ? (
                              <thead>
                                <tr>
                                  <th>Topic</th>
                                  {expertise.map((item) => (
                                    <th key={item._id} className="text-center">
                                      {item.name}
                                    </th>
                                  ))}
                                </tr>
                              </thead>
                            ) : (
                              ''
                            )}
                            <tbody>
                              {(groupedSkills[category] || []).map((skill) =>
                                category.toLowerCase() != 'other skills' ? (
                                  <tr key={skill._id}>
                                    <td>
                                      <Field
                                        type="text"
                                        name={`skills[${skill.realIndex}].name`}
                                        className="form-control"
                                        value={skill.name
                                          .trim()
                                          .split(' ')
                                          .map(
                                            (word) => word.charAt(0).toUpperCase() + word.slice(1)
                                          )
                                          .join(' ')}
                                        readOnly
                                        style={{
                                          border: 'none',
                                          backgroundColor: 'inherit',
                                        }}
                                      />
                                    </td>
                                    {expertise.map((level) => (
                                      <td key={level.name} className="text-center">
                                        <Field
                                          type="radio"
                                          name={`skills[${skill.realIndex}].level-${skill._id}`}
                                          value={level.name}
                                          checked={
                                            values.skills[skill.realIndex][`level-${skill._id}`]
                                              ? values.skills[skill.realIndex][
                                                  `level-${skill._id}`
                                                ] === level.name
                                              : level.name === 'none'
                                          }
                                          onChange={(event) =>
                                            handleChange(skill._id, event.target, setFieldValue)
                                          }
                                        />
                                      </td>
                                    ))}
                                  </tr>
                                ) : (
                                  <Field
                                    as="textarea"
                                    rows="5"
                                    name={`skills[${skill.realIndex}].level-${skill._id}`}
                                    onChange={(event) =>
                                      handleChange(skill._id, event.target, setFieldValue)
                                    }
                                    className="form-control" // optional stylig
                                    placeholder="Enter other skills here... like Skill-Name(Expertise Level)"
                                  />
                                )
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    ));
                  }}
                </FieldArray>

                {/* Submit Button */}
                <div className="d-flex justify-content-end w-100">
                  <Button type="submit" variant="primary" className="mb-4">
                    Submit
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Form>
        )}
      </Formik>
    </>
  ) : (
    <p>Loading skills...</p>
  );
};

const mapStateToProps = (state) => ({
  profile: getProfile(state),
  employeeList: employeeSearchList(state),
});

export default connect(mapStateToProps)(EmployeeSkillForm);
